/**
 * Utility functions for traversing a board object
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import isPlainObject from 'lodash/isPlainObject'

/**
 * Returns an array with a default board order by date descending
 * @param {Object} boards The object containing all boards
 */
export const getDefaultBoardsOrder = (boards = {}) => {
  return Object.keys(boards).map((boardId) => {
    return {
      bid: boardId,
      updatedDate: boards[boardId].meta.updatedDate
    }
  }).sort((a, b) => {
    return b.updatedDate - a.updatedDate
  })
}

/**
 * Returns the list with the specified listPlaceId
 * @param {Object} lists The lists object for a board
 * @param {String} listPlaceId The list place id to find
 */
export const getListWithListPlace = (lists = {}, listPlaceId) => {
  const foundListId = Object.keys(lists).find((lid) => {
    return lists[lid]?.placesOrder?.includes(listPlaceId)
  })

  return (foundListId) ? lists[foundListId] : null
}

/**
 * Returns a boolean that indicates whether the board does not have at least one list place id
 * @param {Object} board The board object
 * @param {Object} lists The lists object
 */
export const isEmptyBoard = (board = {}, lists = {}) => {
  const boardListIds = (isPlainObject(board?.lists))
    ? Object.keys(board?.lists)
    : (board?.lists || [])

  const index = boardListIds.findIndex((lid) => {
    const placesOrder = lists[lid]?.placesOrder || []

    return placesOrder.length > 0
  })

  return (index < 0)
}

/**
 * Returns the photos for a list place based off the board's photoLinks
 * @param {Object} board The board object
 * @param {String} listPlaceId the list place id to search against
 */
export const getListPlacePhotoLink = (board = {}, listPlaceId) => {
  const placePhotos = board.photoLinks?.placePhotos || {}
  const listPlacePhotoLink = (listPlaceId) ? placePhotos[listPlaceId] : {}

  return {
    backgroundPhotoId: listPlacePhotoLink?.backgroundPhotoId,
    photos: listPlacePhotoLink?.photos || []
  }
}
